
let router = [
    {
        // 系统配置管理
        path: 'config',
        component: (resolve => {
            require(["../../function/page_group/main_box"], resolve)
        }),
        children: [
            // 业务配置首页
            {
                path: 'OperationConfigIndex',
                component: (resolve => {
                    require(["../../global/CONFIG/config_index"], resolve)
                })
            },
            // 新建项目页
            {
                path: 'new_project',
                component: (resolve => {
                    require(["./new_building"], resolve)
                })
            },
            // 能耗模型管理
            {
                path: 'edit_energy',
                component: (resolve => {
                    require(["../../global/CONFIG/edit_energy"], resolve)
                })
            },
            // 支路管理页
            {
                path: 'edit_branch',
                component: (resolve => {
                    require(["@/components/IBMS/global/CONFIG/edit_branch"], resolve)
                })
            },
            // 角色管理
            {
                path: 'edit_role',
                component: (resolve => {
                    require(["../../global/CONFIG/edit_role.vue"], resolve)
                })
            },
        ]
    },]
export default router